import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["price", "hint"]
  static values = { available: Boolean }

  connect() {
    this.update()
  }

  update() {
    const bounded = this.priceTargets.some(({ value }) => {
      const amount = Number(value.trim().replace(",", "."))
      return value.trim() !== "" && Number.isFinite(amount) && amount >= 0
    })
    this.hintTarget.hidden = !this.availableValue || !bounded
    for (const price of this.priceTargets) {
      if (this.hintTarget.hidden) price.removeAttribute("aria-describedby")
      else price.setAttribute("aria-describedby", this.hintTarget.id)
    }
  }
}
